import Vue from 'vue';
import ToolTipPanel from 'components/widgets/ToolTipPanel/ToolTipPanel.vue';
import ChartToolTipBody from 'components/widgets/ChartToolTipBody/ChartToolTipBody.vue';
import dayjs from 'dayjs';
export default Vue.extend({
    components: { ToolTipPanel, ChartToolTipBody },
    props: {
        label: { type: String, required: true },
        daysAgo: { type: String, required: false, default: '' },
        freq_1: { type: Number, required: true },
        freq_2: { type: Number, required: true },
        freq_total: { type: Number, required: true },
        freq_percent_1: { type: String, required: true },
        freq_percent_2: { type: String, required: true },
        freq_percent_total: { type: String, required: true },
        freq_diff: { type: Number, required: true },
        freq_diff_percent: { type: String, required: true },
        reldiff: { type: String, required: true },
        customDates: { type: Array, required: true },
        showDrilldown: { type: Boolean, required: false, default: false },
    },
    computed: {
        startDate() {
            return dayjs(this.customDates[0], 'DD/MM/YYYY').format('D MMM, YYYY');
        },
        endDate() {
            return dayjs(this.customDates[1], 'DD/MM/YYYY').format('D MMM, YYYY');
        },
    },
});
